export default {
    type: '',
    category: '',
};
